var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7108 16.3333C12.4167 16.3332 12.1347 16.2104 11.9268 15.9919L7.49129 11.3309C7.28341 11.1124 7.16663 10.8161 7.16663 10.5071C7.16663 10.1981 7.28341 9.90181 7.49129 9.6833L11.9268 5.02236C12.0291 4.91107 12.1515 4.8223 12.2867 4.76123C12.422 4.70016 12.5675 4.66801 12.7148 4.66667C12.862 4.66533 13.008 4.69481 13.1443 4.7534C13.2806 4.81199 13.4044 4.89851 13.5085 5.00792C13.6126 5.11732 13.695 5.24742 13.7507 5.39063C13.8065 5.53383 13.8345 5.68727 13.8333 5.84199C13.832 5.99671 13.8014 6.14961 13.7433 6.29177C13.6852 6.43393 13.6007 6.56251 13.4948 6.67L9.84322 10.5071L13.4948 14.3442C13.6498 14.5072 13.7554 14.7148 13.7981 14.9408C13.8409 15.1668 13.8189 15.4011 13.735 15.6139C13.6511 15.8268 13.509 16.0088 13.3267 16.1368C13.1444 16.2649 12.9301 16.3332 12.7108 16.3333Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.2be75e253fd16901c5a6a7bfbaff0dbe.svg";
export { ForwardRef as ReactComponent };